import { useStyle } from "../style";
import { SvgIcon } from "@mui/material";
import travelIconImg from "@static/img/dashboard/travel.svg";

export const TravelIcon = () => {
    const { classes } = useStyle({});

    return <SvgIcon className={classes.iconBox} component={travelIconImg} viewBox="0 0 30 30" />;
};
